module.exports = __webpack_public_path__ + "img/symbol-fx-right.f965102c.png";